/**
 * @typedef { 'normal'  | 'group' | 'remote_async' | 'form' | 'training' } sessionTypes
 */
export const SESSION_TYPES = {
  NORMAL: 'normal',
  GROUP: 'group',
  REMOTE_ASYNC: 'remote_async',
  FORM: 'form',
  TRAINING: 'training',
};

export const SESSION_TYPES_ARRAY = Object.values(SESSION_TYPES);

// eslint-disable-next-line import/prefer-default-export
export const SESSION_STATUSES = {
  CREATED: 'created',
  SCHEDULED: 'scheduled',
  PREPARING: 'preparing',
  RUNNING: 'running',
  PROCESSING: 'processing',
  DONE: 'done',
  OFFLINE_DONE: 'offline-done', // offline mode specific status
  UNKNOWN: 'unknown',
};
